import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { track } from '../../analytics/track';
import { EVENTS } from '../../analytics/events';
import OrderHistoryTable from './OrderHistoryTable';
import SavedTable from './SavedTable';
import { BuyerDashboardView } from './BuyerDashboard.view';
import { BuyerStats } from './BuyerStats';
import { useCollectionSummary } from './useCollectionSummary';

/**
 * `/dashboard` for a buyer. The container.
 *
 * Behaviour unchanged: `BUYER_DASHBOARD_VIEWED` fires on mount, and the
 * `?tab=saved` / `?tab=order_history` deep link still selects the tab. The
 * tables are the same self-fetching containers the seller's buyer mode mounts,
 * so a collection looks the same whoever is looking at it.
 *
 * WHAT DIED: `BuyerDashboard.css`, the import of `SellerDashboard.css` from
 * another directory, the hand-rolled `Tabe.jsx` tab bar, the local `tabData`
 * array whose `content` fields were never rendered, and `Layout.jsx`.
 */
/**
 * Owns the collection-summary query so the view stays pure and the seller's
 * buyer mode can mount the identical band without duplicating the fetch.
 */
function BuyerStatsPanel() {
  const summary = useCollectionSummary();
  return (
    <BuyerStats
      count={summary.count}
      value={summary.value}
      complete={summary.complete}
      loading={summary.loading}
    />
  );
}

export { BuyerStatsPanel };

const BuyerDashboard = () => {
  const [tab, setTab] = useState('saved');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    track(EVENTS.BUYER_DASHBOARD_VIEWED);
  }, []);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const next = searchParams.get('tab');
    if (next && (next === 'saved' || next === 'order_history')) {
      setTab(next);
    }
  }, [location.search]);

  return (
    <BuyerDashboardView
      tab={tab}
      onTabChange={setTab}
      panel={tab === 'order_history' ? <OrderHistoryTable /> : <SavedTable />}
      onExploreMarketplace={() => navigate('/marketplace')}
      stats={<BuyerStatsPanel />}
    />
  );
};

export default BuyerDashboard;
